import React, { useState, useEffect, useCallback } from "react";
import { getAll, preventDoubleSubmit } from "./utils/helpers";
import { Container, Logo } from "../register/styles";
import PopUp from "../register/components/Popup";
import { ContactInfo, InfoBox, Subtitle, Title } from "./styles";
import RemoveDataForm from "./components/form";
import { pt } from "./text";
import Loading from "../register/components/Loading";
import { sendRemoveDataRequest } from "./api";

const RemoveData = ({ match }) => {
  const [layout, setLayout] = useState();
  const [text, setText] = useState(pt);

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [invalidUrl, setInvalidUrl] = useState(false);
  const [popup, setPopup] = useState(false);
  const [popupList, setPopupList] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    cpf: "",
    phone: "",
    request: "",
    isAware: false,
    isHolder: false,
    understandLegal: false,
    agreeTerms: false,
  });

  const requiredFields= [
    "fullName",
    "email",
    "isHolder",
    "isAware",
    "understandLegal",
    "agreeTerms",
  ];

  const neoId = match.params.neoId;

  useEffect(() => {
    getAll({
      neoId,
      match,
      setLayout,
      setText,
      setInvalidUrl,
      text,
    });
  }, [match, neoId, text]);

  const showLogo = () => {
    if (layout.logo) {
      return (
        <Logo>
          <img
            className="logo_img"
            src={layout.logo}
            alt={`Logo ${layout.nome}`}
          />
        </Logo>
      );
    }
  };

  const showSubmitBtn = () => {
    return (
      <div className="submit_buttons">
        <button type="submit">{text?.enviar}</button>
      </div>
    );
  };

  const showForm = useCallback(
    () => (
      <RemoveDataForm
        layout={layout}
        formData={formData}
        setFormData={setFormData}
        text={text}
        setText={setText}
      />
    ),
    [layout, formData, setFormData, text, setText]
  );

  function setPopupWarning(type, append) {
    setPopupList(false);
    setLoading(false);

    if (type === "loading") setLoading(append);
    else if (append) {
      setPopupList(append);
      setPopup(type);
    } else setPopup(type);
  }

  useEffect(() => {
    setPopupWarning("loading", !!isSubmitting);
  }, [isSubmitting]);

  const handleSubmitOriginal = async (e) => {
    e.preventDefault();

    for (const field of requiredFields) {
      if (!formData[field]) {
        setPopupWarning(`O campo ${text["rules"][field]} é obrigatório.`);
        return;
      }
    }

    setIsSubmitting(true);

    try {
      await sendRemoveDataRequest({
        mdi: neoId,
        nome: formData.fullName,
        email: formData.email,
        solicitacao: formData.request,
        lang: layout?.lang || "ptbr",
      });

      setPopupWarning(text.solicitacaoEnviada);

      setFormData({
        fullName: "",
        email: "",
        cpf: "",
        phone: "",
        request: "",
        isAware: false,
        isHolder: false,
        understandLegal: false,
        agreeTerms: false,
      });
    } catch (error) {
      setPopupWarning(error.message || text.erroEnvio);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = useCallback(
    preventDoubleSubmit(handleSubmitOriginal, 2000),
    [formData, text]
  );

  return layout ? (
    <Container layout={layout}>
      {layout.background && layout.background.includes(".mp4") ? (
        <video id="background-video" autoPlay loop muted>
          <source src={layout.background} type="video/mp4" />
        </video>
      ) : (
        <></>
      )}

      {showLogo()}

      <div className="form_background">
        <Title layout={layout}>{text?.remocaoDados}</Title>
        <Subtitle layout={layout}>{text?.solicitarExclusao}</Subtitle>

        <InfoBox layout={layout}>
          <h3>{text.exercendoDireito}</h3>
          <p>{text.infoPrivacidade}</p>
          <p>
            <strong>{text.infoImportante}</strong> {text.infoPerda}
          </p>
        </InfoBox>

        <form onSubmit={handleSubmit}>
          {showForm()}
          {showSubmitBtn()}
        </form>

        <ContactInfo>
          <h4>{text.precisaAjuda}</h4>
          <p>
            <strong>{text.email}</strong> suporte@neoidea.com.br
          </p>
          <p>
            <strong>{text.prazoResposta}</strong> {text.prazoRespostaTexto}
          </p>
          <p>{text.infoEquipe}</p>
        </ContactInfo>
      </div>

      <Loading loadingStatus={loading} />
      <PopUp setPopup={setPopup} popupStatus={popup} popupList={popupList} />
    </Container>
  ):<><PopUp setPopup={false} popupStatus={invalidUrl} /></>
};

export default RemoveData;
